export const mockData = [
  {
    poNumber: "#73291",
    cogs: "£12,500",
    orderDate: "02.01.24",
    shipmentDate: "03.01.24",
    soNumbers: [
      {
        soNumber: "#92391/1",
        shippingCosts: "£1,200",
        deliveryDate: "06.01.24",
        type: "ship",
      },
      {
        soNumber: "#92391/2",
        shippingCosts: "£1,250",
        deliveryDate: "08.01.24",
        type: "ship",
      },
    ],
  },
  {
    poNumber: "#73292",
    cogs: "£8,750",
    orderDate: "02.01.24",
    shipmentDate: "03.01.24",
    soNumbers: [
      {
        soNumber: "#92392/1",
        shippingCosts: "£900",
        deliveryDate: "07.01.24",
        type: "plane",
      },
    ],
  },
  {
    poNumber: "#73293",
    cogs: "£15,300",
    orderDate: "03.01.24",
    shipmentDate: "05.01.24",
    soNumbers: [
      {
        soNumber: "#92393/1",
        shippingCosts: "£1,300",
        deliveryDate: "08.01.24",
        type: "plane",
      },
      {
        soNumber: "#92393/2",
        shippingCosts: "£1,300",
        deliveryDate: "08.01.24",
        type: "plane",
      },
      {
        soNumber: "#92393/3",
        shippingCosts: "£1,300",
        deliveryDate: "08.01.24",
        type: "ship",
      },
    ],
  },
  {
    poNumber: "#73294",
    cogs: "£9,200",
    orderDate: "04.01.24",
    shipmentDate: "06.01.24",
    soNumbers: [
      {
        soNumber: "#92394/1",
        shippingCosts: "£1,500",
        deliveryDate: "10.01.24",
        type: "plane",
      },
    ],
  },
  {
    poNumber: "#73297",
    cogs: "£10,800",
    orderDate: "07.01.24",
    shipmentDate: "08.01.24",
    soNumbers: [
      {
        soNumber: "#92397/1",
        shippingCosts: "£1,000",
        deliveryDate: "10.01.24",
      },
    ],
  },
];

export const typesIcons = {
  ship: "🚢",
  plane: "✈️",
};
